import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { BsCircleFill } from "react-icons/bs";
import { MdLockOpen } from "react-icons/md";
import { ACCOUNT_STATUSES } from "shared/hooks/useAccountLock";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";

export const AccountStatusBadge = ({ locked }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.COLLABORATOR);
  const ACCOUNT_STATUS = t("LIST.ACCOUNT_STATUS", { returnObjects: true });
  return (
    <div className="d-flex align--center">
      <BsCircleFill color={locked ? COLORS.C_DANGER : COLORS.C_SUCCESS} />
      <span>
        {
          ACCOUNT_STATUS[
            locked ? ACCOUNT_STATUSES.LOCKED : ACCOUNT_STATUSES.ACTIVE
          ]
        }
      </span>
    </div>
  );
};

export const UnlockAction = ({ onUnlock, size = 24 }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.COLLABORATOR);
  return (
    <Tooltip title={t("LIST.UNLOCK")}>
      <MdLockOpen size={size} color={COLORS.C_PRIMARY} onClick={onUnlock} />
    </Tooltip>
  );
};

export const accountStatusColumn = (lockStates, title) =>
  lockStates
    ? [
        {
          title,
          dataIndex: "id",
          key: "accountStatus",
          render: (id) => (
            <AccountStatusBadge locked={lockStates[id] === true} />
          ),
        },
      ]
    : [];

export const AccountFilters = ({
  onLastnameChange,
  onFirstnameChange,
  status,
  onStatusChange,
  statusOptions,
  showStatus,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.COLLABORATOR);
  const FILTERS = t("LIST.FILTERS", { returnObjects: true });
  return (
    <div className="grid--4 m-bottom-24">
      <Input
        type="search"
        placeholder={FILTERS.LAST_NAME}
        onChange={({ target: { value } }) => onLastnameChange(value)}
      />
      <Input
        type="search"
        placeholder={FILTERS.FIRST_NAME}
        onChange={({ target: { value } }) => onFirstnameChange(value)}
      />
      {showStatus && (
        <Select
          allowClear
          placeholder={FILTERS.STATUS}
          options={statusOptions}
          value={status}
          onChange={onStatusChange}
        />
      )}
    </div>
  );
};
